<template>
    <div class="tab-pane active" :id="price_type" role="tabpanel" :aria-labelledby="price_type">
        <div class="dtHinnadWrapper table-responsive">
            <p v-if="price_type === 'eqs'" class="font-weight-bold text-center my-2">
                {{ $t('Additional equipment can be rented without a vehicle') }}
            </p>
            <table class="dtHinnad table table-hover table-striped table-sm sm-price-table w-100">
                <thead>
                    <tr class="table-info">
                        <th scope="col" colspan="2">{{ $t('Name') }}</th>
                        <th v-for="(range, i) in list.ranges" :key="i" scope="col">
                            {{ range.min === 0 ? range.min + 1 : range.min }}-{{ range.max | valueOrDots }} {{ $t('days') }}
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, i) in items" :key="i">
                        <th scope="row" class="p-1 car-table-img">
                            <template v-if="price_type === 'vehicles' && item.imgs.length">
                                <vue-carousel :data="getVehicleImgs(item.imgs)" :controls="false" indicator-type="disc" :indicators="item.imgs.length === 1 ? false : true"/>
                            </template>
                            <img v-if="price_type === 'eqs' && item.dbname" :src="`${envUrl}/additions/${item.dbname}`" height="auto" class="img-thumbnail rounded z-depth-1"/>
                            <div v-else class="card-image rounded z-depth-1">
                                <div class="view car-img pointer" />
                            </div>
                        </th>
                        <th scope="row">
                            <template v-if="price_type === 'eqs'">
                                {{ item.name[locale] }}
                            </template>
                            <template v-else-if="price_type === 'vehicles'">
                                <router-link :to="{ name: 'pub.booking', params: { vehicle_slug: item.slug } }" tag="a">
                                    {{ item.make.name }} {{ item.model.name }} <app-vehicle-no :slug="item.slug"/> <small>({{ $t(item.transmission.name) }})</small>
                                </router-link>
                            </template>
                        </th>
                        <th v-for="(price, j) in item.prices" :key="j">
                            <template v-if="price.discount_price">
                                <span style="text-decoration: line-through">
                                    {{ price.price / 100 }} EUR<br>
                                </span>
                                <span class="text-danger">
                                    {{ price.discount_price / 100 }} EUR
                                </span>
                            </template>
                            <template v-else>
                                {{ price.price / 100 }} EUR
                            </template>
                        </th>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    props: ['list', 'bts', 'eqs'],
    data() {
        return {
            price_type: 'vehicles',
            items: [],
            loading: true
        };
    },
    computed: {
        ...mapGetters(['envUrl', 'locale']),
        allVehicles() {
            let all = [];
            this.bts.map(bt => {
                all.push(...bt.active_vehicles);
            });
            return all;
        }
    },
    methods: {
        getVehicleImgs(imgs) {
            return imgs.map(i => `<img src="${this.envUrl}/vehicles/${i.dbname}" height="auto" class="img-thumbnail rounded z-depth-1"/>`);
        },
        getPriceList(priceType) {
            switch(priceType.split('/').slice(-1).pop()) {
            case 'autod':
                this.items = this.bts.find(bts => bts.name === 'car').active_vehicles;
                break;
            case 'bussid':
                this.items = this.bts.find(bts => bts.name === 'minibus').active_vehicles;
                break;
            case 'kaubikud':
                this.items = this.bts.find(bts => bts.name === 'commercial vehicle').active_vehicles;
                break;
            case 'lisavarustus':
                this.items = this.eqs;
                this.price_type = 'eqs';
                break;
            case 'koik':
                this.items = this.allVehicles;
                break;
            }
            this.loading = true;
        },
    },
    beforeRouteUpdate(to, from, next) {
        this.getPriceList(this.$route.path);
        next();
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.getPriceList(to.path);
        });
    },
    created() {
        this.getPriceList(this.$route.path);
    }
};
</script>
